/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-source.reducer';

export const TumorSourceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorSourceEntity = useAppSelector(state => state.tumorSource.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorSourceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorSource.detail.title">TumorSource</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorSource.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.id}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.tumorSource.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.entityId}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.tumorSource.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.entityType}</dd>
          <dt>
            <span id="entityName">
              <Translate contentKey="tinyMedicRestApp.tumorSource.entityName">Entity Name</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.entityName}</dd>
          <dt>
            <span id="caseNumber">
              <Translate contentKey="tinyMedicRestApp.tumorSource.caseNumber">Case Number</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.caseNumber}</dd>
          <dt>
            <span id="caseType">
              <Translate contentKey="tinyMedicRestApp.tumorSource.caseType">Case Type</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.caseType}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.tumorSource.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.createdBy}</dd>
          <dt>
            <span id="createDate">
              <Translate contentKey="tinyMedicRestApp.tumorSource.createDate">Create Date</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.createDate}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorSource.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.lastUpdated}</dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="tinyMedicRestApp.tumorSource.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.lastModifiedBy}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorSource.active">Active</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorSource.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorSource.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorSource.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tumorSourceEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorSource.unit">Unit</Translate>
          </dt>
          <dd>{tumorSourceEntity.unit ? tumorSourceEntity.unit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorSource.test">Test</Translate>
          </dt>
          <dd>{tumorSourceEntity.test ? tumorSourceEntity.test.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorSource.tumor">Tumor</Translate>
          </dt>
          <dd>{tumorSourceEntity.tumor ? tumorSourceEntity.tumor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-source" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-source/${tumorSourceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorSourceDetail;
